import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlagCheckered } from "@fortawesome/free-solid-svg-icons";
import { PageNavContext } from "../FunctionalPageLoginStart";
import './RightElements.css';

const createMissionsFromDailyData = (dailyData = {}) => {
  const xpToday = Number(dailyData.xp_earned ?? 0);
  const lessonsToday = Number(dailyData.lessons_completed ?? 0);
  const applicationsToday = Number(dailyData.applications_completed ?? 0);

  return [
    { text: 'Castiga 300 XP', progress: xpToday, total: 300 },
    { text: 'Completeaza 3 lectii standard', progress: lessonsToday, total: 3 },
    { text: 'Rezolva o lectie aplicativa', progress: applicationsToday, total: 1 },
  ];
};

const DailyGoalsCard = () => {
  const onPageNav = useContext(PageNavContext);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [missions, setMissions] = useState(createMissionsFromDailyData());

  useEffect(() => {
    const fetchDailyMissions = async () => {
      try {
        const response = await fetch(`${apiUrl}/missions/today`, {
          method: 'GET',
          credentials: 'include',
        });

        if (!response.ok) {
          return;
        }

        const data = await response.json();
        setMissions(createMissionsFromDailyData(data));
      } catch (error) {
        console.error('Eroare la preluarea misiunilor:', error);
      }
    };

    fetchDailyMissions();
  }, [apiUrl]);

  const handleOpenMissions = (event) => {
    event.preventDefault();
    if (onPageNav) {
      onPageNav('Misiuni');
    }
  };

  return (
    <div className="rightmenu-card dailygoals-card">
      <div className="section daily-goals">
        <span className="get-pro-title">Misiuni zilnice</span>
        <a href="#" className="section-link" onClick={handleOpenMissions}>Acceseaza</a>
        <div className="daily-missions-list">
          {missions.map((mission, index) => {
            const percent = mission.total > 0
              ? Math.min(100, Math.round((mission.progress / mission.total) * 100))
              : 0;
            const isCompleted = percent === 100;

            return (
              <div
                key={index}
                className={`daily-mission-item ${isCompleted ? 'daily-mission-completed' : ''}`}
              >
                <div className="daily-mission-header">
                  <div className="daily-mission-text">{mission.text}</div>

                  <div className="daily-mission-right">
                    <span className="daily-mission-percent">{mission.progress} / {mission.total}</span>
                    <FontAwesomeIcon
                      icon={faFlagCheckered}
                      className="daily-mission-flag"
                    />
                  </div>
                </div>

                <div className="daily-mission-progress-bar">
                  <div
                    className="daily-mission-progress-fill"
                    style={{ width: `${percent}%` }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DailyGoalsCard;
